export interface Zone {
  id: string
  slug: string
  name: string
  code: string
  hero_title: string | null
  hero_description: string | null
  intro_heading: string | null
  intro_body: unknown[] | null
  areas: unknown[] | null
  faqs: unknown[] | null
  sort_order: number
  created_at?: string
}

export interface Vendor {
  id: string
  slug: string
  name: string
  zone: string
  phone: string | null
  whatsapp: string | null
  email: string | null
  address: string | null
  specialty: string | null
  rating: number | null
  review_count: number
  verified: boolean
  is_active: boolean
  created_at?: string
}

export interface Part {
  id: string
  vendor_id: string | null
  slug: string
  title: string
  brand: string
  model: string | null
  year: string | null
  category: string
  oem: string | null
  condition: 'New' | 'Used' | 'Grade A' | 'Grade B'
  price_aed: number
  description: string | null
  photo: string | null
  featured: boolean
  is_active: boolean
  created_at?: string
}

export interface WantedOrder {
  id: string
  slug: string
  title: string
  brand: string | null
  model: string | null
  part: string | null
  budget_aed: number | null
  zone: string | null
  buyer: string | null
  whatsapp: string | null
  is_active: boolean
  created_at?: string
}

export interface Profile {
  role: 'admin' | 'owner'
}

export interface Brand {
  id: string
  name: string
  slug: string
  country: string | null
  category: string | null
  logo_url: string | null
  is_active: boolean
  sort_order: number
  created_at?: string
}

export interface Post {
  id: string
  slug: string
  title: string
  excerpt: string | null
  content: string | null
  cover_url: string | null
  author: string | null
  category: string | null
  published_at: string | null
  is_active: boolean
  created_at?: string
}

export interface AdminUser {
  user_id: string
  email: string
  role: string
  created_at: string
}

export const CONDITIONS = ['New', 'Used', 'Grade A', 'Grade B'] as const
export const CATEGORIES = ['Engine', 'Gearbox', 'Body', 'Lighting', 'Electrical', 'Interior', 'Suspension', 'Other'] as const
